/* import __COLOCATED_TEMPLATE__ from './reactions-tab.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();